import { render, staticRenderFns } from "./CreditPackage.vue?vue&type=template&id=06e49c48&"
import script from "./CreditPackage.vue?vue&type=script&lang=js&"
export * from "./CreditPackage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports